// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"41d0d3c1","126":"f17cc2b3","171":"aa534d6b","220":"3b424fd0","453":"64552d38","842":"74498f54","998":"468e125b"}[chunkId] + ".chunk.js";
};